<template>
  <div>
    <v-icon v-if="type === 'STANDARD'">collections</v-icon>
    <v-icon v-else-if="type === 'VIDEO'">video_library</v-icon>
    <v-icon v-else-if="type === 'INSPECTION'">search</v-icon>
    <v-icon v-else-if="type === 'INSPECTION_REPAIR_ORDER'">build</v-icon>
  </div>
</template>

<script>
export default {
  name: 'IconShootingType',

  props: {
    type: {
      type: String,
      default: '',
      require: true
    }
  }
}
</script>
